<template>

        <div class="row">
            <!-- <div class="chart" slot="content"> -->
                <IEcharts
                    :option="EventAnalysisOption"
                    ref="charts"
                    style="width: 100%; height: 100%"
                />
                <!-- <div ref="map1" class="map" style="height:180px"></div> -->
            <!-- </div> -->
        </div>

</template>
<script>
import echarts from "echarts";
import { darkblue } from "color-name";
import IEcharts from "vue-echarts-v3/src/lite.js";
import { mapState } from "vuex";

import axios from "axios";

import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/legend";
import "echarts/lib/component/title";

let Base64 = require("js-base64").Base64;
import network from "./network";
require("echarts-wordcloud");


export default {
    components: {
        IEcharts,
    },
    data() {
        let ws_scheme = window.location.protocol === "https:" ? "wss" : "ws";
        let ws_base_url = `${ws_scheme}://${window.location.host}`;
        let baseUrl = process.env.BASE_URL;
        return {
            //办理事件分析
            EventAnalysisOption: {},
            EventAnalysisData: {},
            network: network,

            PeopleLiveSpecialGroupSankeyGraphOption: {},
        };
    },
    computed: mapState({
        monthData: (state) => state.cityMgt.monthData,
        regionName: (state) => state.cityMgt.regionName,
        orgid: (state) => state.population.orgid,
    }),
    mounted: function () {
        // this.getEventAnalysisData()
        this.setEventAnalysisOption();
        // this.getPeopleLiveSpecialGroupSankeyGraphData()
        // this.getwordCloudData('wordcloud')
    },
    watch: {
        ageCountTreeMap() {
            this.setAgeCountOption();
        },
        populations: {
            handler(newValue, oldValue) {},
            deep: true,
        },
    },
    methods: {
        //办理事件分析
        getEventAnalysisData() {
            let url =
                "/DONGXIANG/dxFrist/getRltFirstPerspectiveEventAnalysis.do";
            let params = {};
            let _this = this;
            this.axios
                .get(url, { params })
                .then(function (res) {
                    let Label = [],
                        Male = [],
                        FeMale = [],
                        Label1 = [],
                        Male1 = [],
                        FeMale1 = [],
                        LabelArr = [];
                    res.data.forEach((element) => {
                        if (element.name == "宣传广告") {
                            Label.push(element.time);
                            Male.push(element.count);
                        } else if (element.name == "市容环境") {
                            FeMale.push(element.count);
                        } else if (element.name == "扩充类别") {
                            Label1.push(element.count);
                        } else if (element.name == "施工管理") {
                            Male1.push(element.count);
                        } else if (element.name == "突发事件") {
                            FeMale1.push(element.count);
                        } else if (element.name == "街面秩序") {
                            LabelArr.push(element.count);
                        }
                    });
                    _this.EventAnalysisData = {
                        Label,
                        Male,
                        FeMale,
                        Label1,
                        Male1,
                        FeMale1,
                        LabelArr,
                    };
                    //   _this.setEventAnalysisOption()
                })
                .catch(function (err) {
                    console.log(err);
                });
        },
        setEventAnalysisOption() {
            let [dataArr, allArr, erArr, hrArr, sanArr] = [[], [], [], [], []];
            // 行为标注 show first row
            // let items=this.network
            console.log(this.network, "ll");
            let items = [
                // {
                //     symbol: "",
                //     name: "私搭乱建",
                //     pointType: "point",
                //     belong: "区城管局",
                //     pointColor: "rgba(217, 0, 27, 1)", // 球颜色
                //     lineStyle: {
                //       color: 'red', // 线颜色
                //     },
                //     effect: {
                //       period: 2, // 箭头快慢
                //       symbolSize: [6, 20], // 箭头大小
                //     },
                //   },

                {
                    symbol: "",
                    pointType: "point",
                    belong: "区房管局",
                    name: "挪用/侵占共有财产",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区房管局",
                    name: "非法获益",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区房管局",
                    name: "非法减免物业费",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区房管局",
                    name: "拒交物业费",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区房管局",
                    name: "泄漏业主资料",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区房管局",
                    name: "其他损害业主利益",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区房管局",
                    name: "非法业主大会筹备",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区房管局",
                    name: "法律责任",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区房管局",
                    name: "干预业主大会",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区房管局",
                    name: "物业纠纷",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区房管局",
                    name: "公用设施出问题",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区房管局",
                    name: "公共绿化维护不及时",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区房管局",
                    name: "公共区域不洁",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区房管局",
                    name: "小区车辆乱停",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区房管局",
                    name: "改动房屋主体结构",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区房管局",
                    name: "改动房屋外观",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区房管局",
                    name: "损坏/占用公共部位、设施",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区水利局",
                    name: "水域附属设施",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区水利局",
                    name: "水域护栏",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区水利局",
                    name: "防汛墙",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区水利局",
                    name: "水域警示牌",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区水利局",
                    name: "堤坝破损",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区水利局",
                    name: "河道不洁（含沟渠、湖面）",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区水利局",
                    name: "水体污染",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区水利局",
                    name: "水源地污染",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区供电局",
                    name: "电力井盖",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区供电局",
                    name: "电缆井盖",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区供电局",
                    name: "电力设施",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区供电局",
                    name: "电力设施标识牌",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区供电局",
                    name: "电力立杆",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区供电局",
                    name: "高压线铁塔",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区供电局",
                    name: "变压器（箱）",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区市场监督局",
                    name: "经营管理",
                },
                // {
                // symbol:"",
                // pointType:"point",
                // belong:"区市场监督局",
                // name:"公共安全事件"
                // }
                // ,
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区市场监督局",
                    name: "无证经营",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区市场监督局",
                    name: "市场管理",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区市场监督局",
                    name: "食品安全",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区市场监督局",
                    name: "生产安全",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区市场监督局",
                    name: "特种设备",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区消防大队",
                    name: "消防火警",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区消防大队",
                    name: "消防设备破损",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区消防大队",
                    name: "消防通道占道",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区消防大队",
                    name: "消防隐患",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区消防大队",
                    name: "消防检查",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区消防大队",
                    name: "消防宣传",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区交通运输局",
                    name: "公交站亭",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区交通运输局",
                    name: "出租车站牌",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区交通运输局",
                    name: "道路损坏",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区交通运输局",
                    name: "黑车拉客",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区交通运输局",
                    name: "交通噪声污染",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区交警大队",
                    name: "信号灯电源井盖",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区交警大队",
                    name: "停车场",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区交警大队",
                    name: "交通护栏",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区交警大队",
                    name: "街面秩序",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区交警大队",
                    name: "其他设施",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "通信公司",
                    name: "通信井盖",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "通信公司",
                    name: "通信交接箱",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "通信公司",
                    name: "通信立杆",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "通信公司",
                    name: "电话亭",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "通信公司",
                    name: "通信设施",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区林业局",
                    name: "古树名木",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区林业局",
                    name: "护树设施",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区林业局",
                    name: "违法砍伐",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区林业局",
                    name: "猎杀售卖被保护动物",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区林业局",
                    name: "故意破坏受保护植被",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "乱搭乱建",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "违法焚烧垃圾",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "临街阳台脏乱差",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "高架挂箱滴水",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "道路积泥",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "道路破损",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "污水横流",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "店面无证装修",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "建筑物外立面不洁",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "乱倒乱排污水、废水",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "人行道板破损",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "侵占公共用地",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "废弃车辆",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "沿街晾晒",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "遮阳篷破损",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "空调室外机滴水、低挂",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "非装饰性吊挂物",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "非法小广告",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "违规标语宣传品",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "违规牌匾标识",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "街头散发小广告",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "广告语言文字不规范",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "违规户外广告",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "广告破损",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "工地物料乱堆放",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "违章建筑",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "工地扬尘",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "施工废弃料",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "施工占道",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "施工扰民",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "施工工地围挡",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "施工工地道路未硬化",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "施工完成后未场光地净",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "施工工地车轮夹带",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "路面塌陷",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "下水道堵塞",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "化粪池满溢",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "污水管满溢",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "低洼积水",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "占道废品收购",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "出店经营",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "乱堆物堆料",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "违法占道经营",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "施放系留气球",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "非机动车乱停放",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "污水井盖",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "中水井盖",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "雨水井盖",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "雨水篦子",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "污水沟",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "违法接管排水",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "其他部件",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "路灯井盖",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "路灯破损、缺亮、缺失",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "地灯破损、缺亮、缺失",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "景观灯破损、缺亮、缺失",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "街头座椅破损、脱落、缺失",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "喷泉破损、缺失、倾斜",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "防撞桶破损、脱落、缺失",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "雕塑破损、缺失、倾斜",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "沿街立面脏、缺、损",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "违章接坡",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "违章挖掘",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "景观亭子",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "桥梁",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "积存垃圾渣土",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "渣土乱倒",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "工地出入口不洁",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "抛洒滴漏",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "垃圾漫溢",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "暴露垃圾",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "废弃家具",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "路面不洁",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "环卫车辆抛洒滴漏",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "公厕管理",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "化粪池井盖",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "沟槽厕所盖板",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "公厕指示牌",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "垃圾间（楼）",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "垃圾箱破损、倾斜",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区城管局",
                    name: "垃圾车不洁",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区园林局",
                    name: "花、草、苗、木破损",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区园林局",
                    name: "绿化带破损、损坏",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区园林局",
                    name: "树木病虫害无人防治",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区园林局",
                    name: "树木无人修剪",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区人社局",
                    name: "劳动仲裁",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区人社局",
                    name: "社会保障（工伤）",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区人社局",
                    name: "劳动监察",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区自来水公司",
                    name: "自来水管破裂",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区自来水公司",
                    name: "上水井盖",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区自来水公司",
                    name: "水井",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "街道社区",
                    name: "安装扶手和道板",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区公安局",
                    name: "公安井盖",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区公安局",
                    name: "公共安全事件",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区住建局",
                    name: "施工管理（工地）",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区住建局",
                    name: "房屋建设（房屋内部）",
                },
                // {
                // symbol:"",
                // pointType:"point",
                // belong:"电信公司",
                // name:"通信井盖"
                // }
                // ,
                // {
                // symbol:"",
                // pointType:"point",
                // belong:"电信公司",
                // name:"通信交接箱"
                // }
                // ,
                // {
                // symbol:"",
                // pointType:"point",
                // belong:"电信公司",
                // name:"通信立杆"
                // }
                // ,
                // {
                // symbol:"",
                // pointType:"point",
                // belong:"电信公司",
                // name:"电话亭"
                // }
                // ,
                // {
                // symbol:"",
                // pointType:"point",
                // belong:"电信公司",
                // name:"通信设施"
                // }
                // ,
                // {
                // symbol:"",
                // pointType:"point",
                // belong:"联通公司",
                // name:"通信井盖"
                // }
                // ,
                // {
                // symbol:"",
                // pointType:"point",
                // belong:"联通公司",
                // name:"通信交接箱"
                // }
                // ,
                // {
                // symbol:"",
                // pointType:"point",
                // belong:"联通公司",
                // name:"通信立杆"
                // }
                // ,
                // {
                // symbol:"",
                // pointType:"point",
                // belong:"联通公司",
                // name:"电话亭"
                // }
                // ,
                // {
                // symbol:"",
                // pointType:"point",
                // belong:"联通公司",
                // name:"通信设施"
                // }
                // ,
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区燃气公司",
                    name: "燃气管道破裂",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "区燃气公司",
                    name: "其他",
                },
                // {
                // symbol:"",
                // pointType:"point",
                // belong:"区人社局",
                // name:"其他"
                // }
                // ,

                {
                    symbol: "",
                    pointType: "point",
                    belong: "区教体局",
                    name: "体育健身设施",
                },
                // {
                // symbol:"",
                // pointType:"point",
                // belong:"区教体局",
                // name:""
                // }
                // ,

                {
                    symbol: "",
                    pointType: "point",
                    belong: "小贝单车",
                    name: "单车乱停乱放",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "蜜果单车",
                    name: "单车乱停乱放",
                },
                {
                    symbol: "",
                    pointType: "point",
                    belong: "街道社区",
                    name: "道路破损",
                    effect: {
                        period: 4,
                    },
                },
                {
                    symbol: "",
                    name: "区房管局",
                    pointType: "cloud",
                    belong: "东乡城市运行\n管理指挥中心",
                },
                {
                    symbol: "",
                    name: "区水利局",

                    pointType: "cloud",
                    belong: "东乡城市运行\n管理指挥中心",
                },
                {
                    symbol: "",
                    name: "区供电局",

                    pointType: "cloud",
                    belong: "东乡城市运行\n管理指挥中心",
                },
                {
                    symbol: "",
                    name: "区市场监督局",

                    pointType: "cloud",
                    belong: "东乡城市运行\n管理指挥中心",
                },
                {
                    symbol: "",
                    name: "区消防大队",

                    pointType: "cloud",
                    belong: "东乡城市运行\n管理指挥中心",
                },
                {
                    symbol: "",
                    name: "区交通运输局",

                    pointType: "cloud",
                    belong: "东乡城市运行\n管理指挥中心",
                },
                {
                    symbol: "",
                    name: "区交警大队",

                    pointType: "cloud",
                    belong: "东乡城市运行\n管理指挥中心",
                },
                {
                    symbol: "",
                    name: "通信公司",

                    pointType: "cloud",
                    belong: "东乡城市运行\n管理指挥中心",
                },
                {
                    symbol: "",
                    name: "区林业局",

                    pointType: "cloud",
                    belong: "东乡城市运行\n管理指挥中心",
                },
                {
                    symbol: "",
                    name: "区城管局",

                    pointType: "cloud",
                    belong: "东乡城市运行\n管理指挥中心",
                },
                {
                    symbol: "",
                    name: "区园林局",

                    pointType: "cloud",
                    belong: "东乡城市运行\n管理指挥中心",
                },
                {
                    symbol: "",
                    name: "区人社局",

                    pointType: "cloud",
                    belong: "东乡城市运行\n管理指挥中心",
                },
                {
                    symbol: "",
                    name: "区自来水公司",

                    pointType: "cloud",
                    belong: "东乡城市运行\n管理指挥中心",
                },
                {
                    symbol: "",
                    name: "街道社区",

                    pointType: "cloud",
                    belong: "东乡城市运行\n管理指挥中心",
                    effect: {
                        period: 2,
                        // symbolSize: [8, 24],
                    },
                },
                {
                    symbol: "",
                    name: "区公安局",

                    pointType: "cloud",
                    belong: "东乡城市运行\n管理指挥中心",
                },
                // {
                // symbol:"",
                // name:"区住建局",

                // pointType:"cloud",
                // }
                // ,

                // {
                // symbol:"",
                // name:"电信公司",

                // pointType:"cloud",
                // }
                // ,
                // {
                // symbol:"",
                // name:"联通公司",

                // pointType:"cloud",
                // }
                // ,
                {
                    symbol: "",
                    name: "区燃气公司",
                    pointType: "cloud",
                    belong: "东乡城市运行\n管理指挥中心",
                },
                {
                    symbol: "",
                    name: "区教体局",

                    pointType: "cloud",
                    belong: "东乡城市运行\n管理指挥中心",
                },
                {
                    symbol: "",
                    name: "小贝单车",

                    pointType: "cloud",
                    belong: "东乡城市运行\n管理指挥中心",
                },
                {
                    symbol: "",
                    name: "东乡城市运行\n管理指挥中心",
                    pointType: "yuan",
                    //   belong: "111",
                },
                // {
                // symbol:"",
                // name:"蜜果单车",

                // pointType:"cloud",
                // }
                // ,
            ];
            console.log(items, "oo");
            // 点
            // let data = {
            //         name: "抚州市东乡区\n党建+城市大脑",
            //         symbol:"",
            //         pointType:"yuan",
            //     };
            items.forEach((el, ind) => {
                if (el.pointType === "yuan") {
                    // 云
                    console.log(el);
                    el.symbol =
                        "image://data:image/png;base64,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";
                    el.symbolSize = [400, 300];
                    el.label = {
                        normal: {
                            show: true,
                            position: ["15%", "50%"],
                            // fontSize:20,
                            fontWeight: 700,
                            fontFamily: "微软雅黑",
                            // borderWidth: 3,
                            // borderRadius: 12,
                            fontSize: "34",
                            padding: [4, 8, 4, 8],
                            distance: 0,
                            color: "#893448",
                            borderColor: "rgb(89,197,238)",
                        },
                    };
                    hrArr.push(el);
                }
                if (el.pointType === "cloud") {
                    // 云
                    el.symbol =
                        "image://data:image/png;base64,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";
                    el.symbolSize = [112, 70];
                    el.label = {
                        normal: {
                            show: true,
                            position: "bottom",
                            borderWidth: 1,
                            borderRadius: 12,
                            padding: [4, 8, 4, 8],
                            distance: 10,
                            fontSize: "20",
                            color: "rgb(255,255,255)",
                            borderColor: "rgb(89,197,238)",
                        },
                    };
                    erArr.push(el);
                } else if (el.pointType === "point") {
                    // 球
                    el.itemStyle = {
                        borderColor: el.pointColor
                            ? el.pointColor
                            : "rgba(4, 242, 28, 1)",
                        borderWidth: 3,
                        color: "#0ceffd",
                    };
                    // 清除没有父节点的值
                    // sanArr.push(el);
                    if (
                        el.belong &&
                        !items.some((iteP) => el.belong === iteP.name)
                    ) {
                        items.splice(ind, 1);
                    } else {
                        sanArr.push(el);
                    }
                }
                if (!el.belong) {
                    el.children = [];
                    items.forEach((es) => {
                        if (es.belong === el.name) {
                            el.children.push(es);
                        }
                    });
                    allArr.push(el);
                }
            });

            // 圆形分区
            function group(arr, r, isTrue = true) {
                //数组 半径
                const newArray = [];
                const { length: arLen } = arr;
                arr.forEach((e, ind) => {
                    // 按角度均匀分布

                    let ang = 90 - (360 / arLen).toFixed(2) * (ind + 1);
                    // console.log(ind)
                    //   let e_index=0;
                    // erArr.forEach((item,index)=>{
                    //     if(item.children[0].belong==e.belong){
                    //         e_index=90 - (360 / erArr.length).toFixed(2) * (index + 1);
                    //     }
                    // })
                    // // 偏移角度
                    // // console.log(e_index)
                    // isTrue===true?ang= 110-(e.children.length/ sanArr.length*360).toFixed(2) * (ind + 1):ang= 90-(360/ arLen).toFixed(2) * (ind + 1);

                    const x = Math.cos((ang * Math.PI) / 180).toFixed(2) * r;
                    const y = Math.sin((ang * Math.PI) / 180).toFixed(2) * r;
                    // 角度 初始

                    e.value = [x.toFixed(2), y.toFixed(2)];
                    console.log(e);
                    if (e.pointType === "point") {
                        let rotate = "";
                        const angle = (80 / arLen).toFixed(2);
                        if (x > 0 && y >= 0) {
                            rotate = (r - angle * ind).toFixed(2);
                            // rotate = (90 - 360 / arLen * (ind + 1)).toFixed(2);
                        } else if (x <= 0 && y > 0) {
                            rotate = (-r + angle * (arLen - ind)).toFixed(2);
                        } else if (x < 0 && y <= 0) {
                            rotate = (r - angle * (ind - arLen * 0.5)).toFixed(
                                2
                            );
                        } else if (x >= 0 && y < 0) {
                            rotate = (
                                -8 +
                                angle * (arLen * 0.25 - ind)
                            ).toFixed(2);
                        }
                        e.label = {
                            show: true,
                            width: 200,
                            color: {
                                lineColor: {
                                    color: "rgb(24,163,239)",
                                },
                            },
                            rotate,
                            align: x > 0 ? "left" : "right",
                            padding: x > 0 ? [0, 0, 0, 16] : [0, 16, 0, 0],
                        };
                    }
                    newArray.push(e);
                });
                return newArray;
            }

            // function lineGroup(arr, r) {
            //   const newArray = [];
            //   const { length: arLen } = arr;
            //   arr.forEach((e, ind) => {
            //     // 按角度均匀分布
            //     const ang = -90 - (360 / arLen).toFixed(2) * (ind + 1);
            //     //
            //     const x = (Math.cos(ang * Math.PI / 180)).toFixed(2) * r;
            //     const y = (Math.sin(ang * Math.PI / 180)).toFixed(2) * r;
            //     // 角度 初始

            //     e.value = [x.toFixed(2), y.toFixed(2)];
            //     if (e.belong) {
            //       let rotate = '';
            //       const angle = (80 / arLen).toFixed(2);
            //       if (x > 0 && y >= 0) {
            //         rotate = (r - angle * (ind)).toFixed(2);
            //         // rotate = (90 - 360 / arLen * (ind + 1)).toFixed(2);
            //       } else if (x <= 0 && y > 0) {
            //         rotate = (-r + angle * (arLen - ind)).toFixed(2);
            //       } else if (x < 0 && y <= 0) {
            //         rotate = (r - angle * (ind - arLen * 0.5)).toFixed(2);
            //       } else if (x >= 0 && y < 0) {
            //         rotate = (-8 + angle * (arLen * 0.25 - ind)).toFixed(2);
            //       }
            //       e.label = {
            //         show: true,
            //         width: 200,
            //         color: {
            //           lineColor: {
            //             color: "rgb(24,163,239)",
            //           },
            //         },
            //         rotate,
            //         align: x > 0 ? 'left' : 'right',
            //         padding: x > 0 ? [0, 0, 0, 16] : [0, 16, 0, 0],
            //       };
            //     }
            //     newArray.push(e);
            //   });
            //   return newArray;
            // }
            // 线配置
            function linesConfig(arr, r) {
                const [dataArr, targetCoord] = [[], [0, 0]];
                arr.forEach((el) => {
                    if (!el.belong) {
                        dataArr.push([
                            { coord: targetCoord },
                            {
                                coord: el.value,
                                lineStyle: el.lineStyle,
                                effect: {
                                    symbolSize: [4, 16], // 动画的大小
                                    period: 6, // 时间快慢
                                    delay: 2, // 延时计算
                                    ...el.effect,
                                },
                            },
                        ]);
                        arr.forEach((element) => {
                            if (element.belong === el.name) {
                                dataArr.push([
                                    { coord: el.value },
                                    {
                                        coord: element.value,
                                        lineStyle: element.lineStyle,
                                        effect: {
                                            symbolSize: [4, 8], // 动画的大小
                                            period: 6, // 时间快慢
                                            delay: 2, // 延时计算
                                            ...element.effect,
                                        },
                                    },
                                ]);
                                //   debugger
                            }
                            arr.forEach((content) => {
                                if (content.belong === element.name) {
                                    // console.log(element)
                                    dataArr.push([
                                        {
                                            coord: element.value,
                                        },
                                        {
                                            coord: content.value,
                                            lineStyle: content.lineStyle,
                                            effect: {
                                                symbolSize: [4, 8], // 动画的大小
                                                period: 6, // 时间快慢
                                                delay: 2, // 延时计算
                                                ...content.effect,
                                            },
                                        },
                                    ]);
                                }
                            });
                        });
                    }
                });
                return dataArr;
            }
            // 点分布
            hrArr = group(hrArr, 0);
            erArr = group(erArr, 36);
            sanArr = group(sanArr, 50, false);
            allArr = [...hrArr, ...erArr, ...sanArr];
            // 线坐标和配置
            dataArr = linesConfig(allArr);
            this.EventAnalysisOption = {
                // backgroundColor: '#000',
                xAxis: {
                    show: false,
                    type: "value",
                    max: 50,
                    min: -51,
                },
                grid: {
                    top: "10%",
                    bottom: "10%",
                    left: "10%",
                    right: "10%",
                },
                yAxis: {
                    show: false,
                    type: "value",
                    max: 50,
                    min: -50,
                },
                series: [
                    {
                        type: "graph",
                        coordinateSystem: "cartesian2d",
                        z: 3,
                        itemStyle: {
                            normal: {
                                shadowColor: "none",
                            },
                        },
                        label: {
                            fontSize: "14",
                        },
                        data: allArr,
                    },
                    {
                        name: "",
                        type: "lines",
                        coordinateSystem: "cartesian2d",
                        polyline: true,
                        z: 1,
                        lineStyle: {
                            width: 2,
                            color: "#fff",
                            curveness: 0,
                        },
                        effect: {
                            show: true,
                            smooth: false,
                            trailLength: 0, // 拖尾的长度
                            symbol: "pin", // 动画的类型
                        },
                        data: dataArr,
                    },
                ],
            };
        },
    },
};
</script>
<style scoped>
.content {
    position: relative;
}
.title {
    position: absolute;
    width: 410px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    top: 0px;
    left: 280px;
    font-size: 30px;
    color: #fff;
    background: rgb(21, 30, 61);
    z-index: 100;
}
.row {
  position: relative;
  height: 800px;
}
.chart {
  position: absolute;
  top: 275px;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>